var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhoiTaoMau05Cdae3E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4354",
    "data-name": "Ellipse 4354",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.298,
    y1: 1.4,
    x2: 0.343,
    y2: 0.111,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_76021",
    x: -5.612,
    y: 18.085,
    width: 63.418,
    height: 73.665,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 1.121,
    y2: 0.819,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_76034",
    x: -18.329,
    y: -2.693,
    width: 120.851,
    height: 132.215,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#007aff",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.897,
    y2: 0.416,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ecf2",
    stopOpacity: 0.349
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.355,
    y1: 0.327,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f32b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6ff6",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KhoiTaoMau",
    transform: "translate(-448.5 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53135",
    "data-name": "Group 53135",
    transform: "translate(11261.5 5832)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4349",
    "data-name": "Ellipse 4349",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10813 -5522)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-10813 -5522)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53268",
    "data-name": "Group 53268",
    transform: "translate(10805 5382.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53267",
    "data-name": "Group 53267",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, -10776.851, -5373.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53223",
    "data-name": "Group 53223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76021-2",
    "data-name": "Path 76021",
    d: "M.03,46.15a1,1,0,0,0,.725,1.207l23.372,5.827a1,1,0,0,0,.772-.124l6.639-4.184,6.547-4.227a1,1,0,0,0,.426-.6L47.085,9.665a1,1,0,0,0-.725-1.207L12.555.03a1,1,0,0,0-1.207.725Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 12.194)",
    fill: "#007aff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22855",
    "data-name": "Rectangle 22855",
    width: 27.445,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 13.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22856",
    "data-name": "Rectangle 22856",
    width: 26.722,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 18.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22898",
    "data-name": "Rectangle 22898",
    width: 19.625,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 30.917)",
    fill: "#71b5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22899",
    "data-name": "Rectangle 22899",
    width: 19.625,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 35.279)",
    fill: "#71b5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22900",
    "data-name": "Rectangle 22900",
    width: 19.625,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 40.367)",
    fill: "#71b5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22901",
    "data-name": "Rectangle 22901",
    width: 19.625,
    height: 2.181,
    rx: 1.09,
    transform: "translate(16.313 45.455)",
    fill: "#71b5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53265",
    "data-name": "Group 53265",
    transform: "translate(-10801.612 -5352.027) rotate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53223-2",
    "data-name": "Group 53223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 1.35, -30.19)",
    filter: "url(#Path_76021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76021-3",
    "data-name": "Path 76021",
    d: "M13,664.027A1.027,1.027,0,0,1,14.027,663H38.886a1.028,1.028,0,0,1,.742.316l5.6,5.847,5.5,5.867a1.028,1.028,0,0,1,.278.7v36.577a1.027,1.027,0,0,1-1.027,1.027H14.027A1.027,1.027,0,0,1,13,712.311Z",
    transform: "translate(-113.17 -622.77) rotate(-9)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_76022",
    "data-name": "Path 76022",
    d: "M127.393,665.112v10.561L115,663h10.237A2.134,2.134,0,0,1,127.393,665.112Z",
    transform: "translate(-89.386 -662.999)",
    fill: "#aee8fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22855-2",
    "data-name": "Rectangle 22855",
    width: 18.555,
    height: 2.53,
    rx: 1.265,
    transform: "translate(5.061 4.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22856-2",
    "data-name": "Rectangle 22856",
    width: 9.278,
    height: 2.53,
    rx: 1.265,
    transform: "translate(5.061 10.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22857",
    "data-name": "Rectangle 22857",
    width: 27.224,
    height: 18.235,
    rx: 4,
    transform: "translate(5.265 19.391)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76023",
    "data-name": "Path 76023",
    d: "M57.5,739v18.106",
    transform: "translate(-46.071 -719.481)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76024",
    "data-name": "Path 76024",
    d: "M87,739v18.106",
    transform: "translate(-67.995 -719.481)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76025",
    "data-name": "Path 76025",
    d: "M115,739v18.106",
    transform: "translate(-88.804 -719.481)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76026",
    "data-name": "Path 76026",
    d: "M60.481,756H33",
    transform: "translate(-27.863 -732.115)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76027",
    "data-name": "Path 76027",
    d: "M60.481,774H33",
    transform: "translate(-27.863 -745.492)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76028",
    "data-name": "Path 76028",
    d: "M60.481,791H33",
    transform: "translate(-27.863 -758.126)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M-12101.988-5837.571l10.541,12.395v-12.395Z",
    transform: "translate(12129.472 5849.899)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53264",
    "data-name": "Group 53264",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, -10779.88, -5348.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53224",
    "data-name": "Group 53224",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, -0.09, 0.09, 1, -27.93, -30.99)",
    filter: "url(#Path_76034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76034-2",
    "data-name": "Path 76034",
    d: "M0,1.042A1.042,1.042,0,0,1,1.042,0H26.253A1.042,1.042,0,0,1,27,.321l5.683,5.93L38.266,12.2a1.042,1.042,0,0,1,.282.713V50.009a1.042,1.042,0,0,1-1.042,1.042H1.042A1.042,1.042,0,0,1,0,50.009Z",
    transform: "matrix(1, 0.09, -0.09, 1, 25.12, 33.31)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_76035",
    "data-name": "Path 76035",
    d: "M4.688,0A1.042,1.042,0,0,0,3.646,1.042V3.386a.261.261,0,0,1-.26.26H1.042a1.042,1.042,0,1,0,0,2.084H3.386a.261.261,0,0,1,.26.26V8.335a1.042,1.042,0,1,0,2.084,0V5.991a.261.261,0,0,1,.26-.26H8.335a1.042,1.042,0,1,0,0-2.084H5.991a.261.261,0,0,1-.26-.26V1.042A1.042,1.042,0,0,0,4.688,0Z",
    transform: "translate(14.586 20.837)",
    fill: "#8ca0bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22874",
    "data-name": "Rectangle 22874",
    width: 27.609,
    height: 38.809,
    rx: 4,
    transform: "translate(5.339 6.902)",
    fill: "rgba(194,210,232,0.26)",
    stroke: "#e3eaf3",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76036",
    "data-name": "Path 76036",
    d: "M0,10.419V0L11.981,12.5h-9.9A2.084,2.084,0,0,1,0,10.419Z",
    transform: "translate(26.567 0)",
    fill: "#cfd7e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76041",
    "data-name": "Path 76041",
    d: "M0,0,10.688,12.569V0Z",
    transform: "translate(27.859 12.502)",
    fill: "url(#linear-gradient-3)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53259",
    "data-name": "Group 53259",
    transform: "translate(502.5 363.209)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4386",
    "data-name": "Ellipse 4386",
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5,
    transform: "translate(0 -0.209)",
    fill: "#9c6ff6",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75996",
    "data-name": "Path 75996",
    d: "M37.04,227.39l-9.312-9.89L19.5,230.2l6.8,6.976Z",
    transform: "translate(-12.524 -211.906)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75997",
    "data-name": "Path 75997",
    d: "M24.678,225.869a.821.821,0,0,1,1.084.02l1.491,1.491,1.491,1.49a.821.821,0,0,1,.02,1.084,3.112,3.112,0,0,0-.772,2.548c.131.544-.062,1.258-.606,1.388l-7.6,1.818a.715.715,0,0,1-.862-.862l1.818-7.6c.13-.544.844-.737,1.388-.606A3.113,3.113,0,0,0,24.678,225.869Zm.571,5.324a1.247,1.247,0,0,1-.862.366,1.083,1.083,0,0,0-.764.248L21.2,234.229a.536.536,0,0,1-.759,0h0a.536.536,0,0,1,0-.759l2.421-2.421a1.082,1.082,0,0,0,.247-.764,1.252,1.252,0,1,1,2.137.909Z",
    transform: "translate(-12.141 -217.156)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53204",
    "data-name": "Group 53204",
    transform: "translate(11.716 5.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22832",
    "data-name": "Rectangle 22832",
    width: 8.228,
    height: 3.935,
    rx: 1.967,
    transform: "translate(2.782 0) rotate(45)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhoiTaoMau05Cdae3E);
export default __webpack_public_path__ + "static/media/KhoiTaoMau.05cdae3e.1b7c23d056015db9bbce1a3255a43ead.svg";
export { ForwardRef as ReactComponent };